<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <p class="f16">指定用户转账手续费限免</p>
    <div class="mt20">
      <label>限免时间：</label>
      <el-date-picker
        style="width: 300px"
        v-model="rangeDate"
        type="daterange"
        range-separator="-"
        value-format="timestamp"
        :default-time="['00:00:00', '23:59:59']"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <p class="mt20 mb10">banner图：</p>
    <div class="upload-btn">
      <img v-if="form.bannerUrl" class="banner-img" :src="form.bannerUrl" alt="">
      <el-button v-else type="primary" icon="el-icon-upload" plain>点击上传</el-button>
      <input @change="(e) => changeFile(e, 1)" accept=".png,.jpg.jpeg" type="file" />
    </div>
    <p class="mt20 mb10">手续费标签图：</p>
    <div class="upload-btn">
      <img v-if="form.tagUrl" class="tag-img" :src="form.tagUrl" alt="">
      <el-button v-else type="primary" icon="el-icon-upload" plain>点击上传</el-button>
      <input @change="(e) => changeFile(e, 2)" accept=".png,.jpg.jpeg" type="file" />
    </div>
    <p class="mt20 mb10">用户Id：</p>
    <div class="upload-container">
      <div class="upload-btn">
        <el-button type="primary" icon="el-icon-upload" plain>点击上传</el-button>
        <input @change="(e) => changeFile(e, 3)" accept=".xls,.xlsx" type="file" />
      </div>
      <el-button type="text" @click="downloadTemplate">下载文件模板</el-button>
    </div>
    <p class="mt10 gray">只能上传.xls .xlsx</p>
    <template v-if="form.fileName">
      <div class="file-item bg-gray"><i class="el-icon-document"></i> {{ form.fileName }}</div>
      <el-button class="ml20" type="text" size="mini" @click="downloadFile(form.fileUrl)">下载</el-button>
    </template>

    <div class="mt20">
      <el-button type="primary" @click="submitUpload">保存生效</el-button>
    </div>

    <el-dialog title="保存失败" :visible.sync="dialogVisible" width="400px">
      <p v-if="uploadResultFileUrl"><el-link type="primary" @click="downloadResultFile">下载文件解析结果</el-link>（请根据错误原因更新文件后重新提交）</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Client from "@/utils/client.js";
import { downloadUrlFile } from '@/utils/functions';
import { fileUpload } from '../../api/merchants';
import {
  importServiceFeeUser,
  getServiceFeeUser,
  queryImageInfo,
} from './api';

export default {
  data() {
    return {
      fullscreenLoading: false,
      rangeDate: [],
      form: {
        fileUrl: null,
        fileName: null,
        bannerUrl: null,
        tagUrl: null,
        tagWidth: null,
        tagHeight: null,
      },
      dialogVisible: false,
      uploadResultFileUrl: null,
    };
  },
  mounted() {
    this.getServiceFeeUser();
  },
  methods: {
    getServiceFeeUser() {
      getServiceFeeUser().then(res => {
        if (res.data && res.data.success) {
          if (res.data.data.startTime) {
            this.rangeDate = [res.data.data.startTime, res.data.data.endTime];
          }
          res.data.data.sellerTagVOList = res.data.data.sellerTagVOList || [];
          this.form = res.data.data;
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
      })
    },
    async changeFile(e, type) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        const file = e.target.files[0];
        if ((type === 1 || type === 2) && !/\.(png|jpe?g)(\?.*)?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.jpg .jpeg .png格式');
          return;
        }
        if (type === 3 && !/\.xlsx?$/.test(String(file.name).toLowerCase())) {
          this.$message.error('只能上传.xls .xlsx格式');
          return;
        }
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件太大了');
          return;
        }
        this.fullscreenLoading = true;
        const confRes = await fileUpload();
        const OSSClient = Client(confRes.data.data);
        const fileName = this.random_string(6) + '_' + new Date().getTime() + '.' + file.name.split('.').pop();
        const random_name = 'tmp/' + fileName;
        const res = await OSSClient.put(random_name, file);
        if (type === 1) {
          this.form.bannerUrl = res.url;
        } else if (type === 2) {
          const resInfo = await queryImageInfo(res.url);
          if (resInfo.data && resInfo.data.ImageWidth) {
            this.form.tagUrl = res.url;
            this.form.tagWidth = resInfo.data.ImageWidth.value;
            this.form.tagHeight = resInfo.data.ImageHeight.value;
          }
        } else if (type === 3) {
          this.form.fileUrl = res.url;
          this.form.fileName = file.name.substring(file.name.lastIndexOf('/'));
        }
        this.fullscreenLoading = false;
      }
      e.target.value = '';
    },
    random_string(len) {
      len = len || 32;
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678', maxPos = chars.length, pwd = '';
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    submitUpload() {
      if (!this.rangeDate && this.rangeDate.length !== 2) {
        this.$message('请选择限免时间');
        return;
      }
      if (!this.form.fileUrl) {
        this.$message('请上传导入文件');
        return;
      }
      this.uploadResultFileUrl = null;
      this.$confirm(`确认信息无误？`, '确认', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        importServiceFeeUser({
          ...this.form,
          startTime: this.rangeDate[0],
          endTime: this.rangeDate[1],
        }).then((res) => {
          if (res.data && res.data.success) {
            if (res.data.code === '1001') {
              this.uploadResultFileUrl = res.data.data;
              this.dialogVisible = true;
            } else {
              this.$message.success('保存成功');
              this.getServiceFeeUser();
            }
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
        });
      }).catch(() => {});
    },
    downloadTemplate() {
      this.downloadFile('https://product-sts.oss-cn-shanghai.aliyuncs.com/tmp/608cb47e-f0ee-499b-a4dd-f1a26213c324.xlsx');
    },
    downloadFile(url) {
      downloadUrlFile(url);
    },
    downloadResultFile() {
      this.downloadFile(this.uploadResultFileUrl);
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
  font-size: 14px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mb10 {
  margin-bottom: 10px;
}
.gray {
  color: #939da9;
}
.bg-gray {
  background-color: #f2f2f2;
}
.f16 {
  font-size: 16px;
}
.upload-btn {
  position: relative;
  display: inline-block;
  margin-right: 50px;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
.upload-container {
  display: flex;
}
.table {
  margin-top: 10px;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: left;
  td,th {
    padding: 5px 0;
  }
  .w300 {
    width: 300px;
  }
  .w230 {
    width: 230px;
  }
}
.file-item {
  display: inline-block;
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 4px;
}
.tag-img {
  display: block;
  max-width: 135px;
}

.banner-img {
  display: block;
  max-width: 200px;
}
</style>
